
<template>
	<div class="animated-logo">
		<object type="image/svg+xml" data="../../static/images/animatedLogo.svg"></object>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		name: 'AnimatedLogo',
		props: {},
	};
</script>

<style scoped>
	.animated-logo {
        width: 40%;
		margin: auto;
        margin-bottom: 20px;
        margin-top: 10px
    }
</style>



// WEBPACK FOOTER //
// src/components/AnimatedLogo.vue